import { Box, styled } from "@mui/material";

export const CompanyManagementMainContentStyles = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "auto",
  gap: "48px",
  padding: "40px",
  marginTop: theme.spacing(3),
  backgroundColor: theme.palette.grey[100],
  borderRadius: "12px",
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
  [theme.breakpoints.down(1440)]: {
    gridTemplateColumns: "1fr",
    gap: "30px",
    padding: "20px",
  },
}));

export const SEPAInstructionsStyles = styled(Box)(({ theme }) => ({
  gridColumn: "1 / -1",
  padding: "20px",
  backgroundColor: theme.palette.background.default,
  borderRadius: "12px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  borderLeft: `4px solid ${theme.palette.primary.light}`,
  marginTop: "32px",
  fontFamily: `"Roboto", "Arial", sans-serif`,
  ".MuiTypography-root": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.4",
    color: theme.palette.text.secondary,
    "&:first-child": {
      fontSize: "1rem",
      fontWeight: "700",
      marginBottom: "12px",
      color: theme.palette.text.primary,
    },
    "&:last-child": {
      marginTop: "10px",
      a: {
        color: theme.palette.primary.dark,
        fontWeight: "500",
        textDecoration: "underline",
      },
    },
  },
}));
export const CompanyManagementTableStyles = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  background: theme.palette.backgroundColor.main,
  width: "100%",
  minWidth: "0",
}));

export const CompanyInfoTableRowStyles = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "24px 33px",
  fontSize: "1.25rem",
  lineHeight: "1.5",
  borderBottom: `1px solid ${theme.palette.border.main}`,
  boxSizing: "border-box",
  transition: "background-color 0.3s ease",
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
  },
  "&:last-child": {
    border: "none",
  },
  [theme.breakpoints.down(1600)]: {
    padding: "18px 24px",
    fontSize: "1.125rem",
    lineHeight: "1.4",
  },
  ".MuiTypography-root": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  ".MuiBox-root": {
    "&:first-child": {
      width: "209px",
      paddingRight: "10px",
      boxSizing: "border-box",
    },
    "&:last-child": {
      minWidth: "0",
      maxWidth: "calc(100% - 209px)",
      ".MuiTypography-root": {
        fontWeight: "600",
        maxWidth: "100%",
      },
    },
  },
}));

export const CompanyTableTitle = styled(CompanyInfoTableRowStyles)({
  fontWeight: "600",
});

export const EmptyRow = styled(CompanyInfoTableRowStyles)({
  minHeight: "72px",
});

export const InvalidBillingAdressRow = styled(Box)(({ theme }) => ({
  padding: "20px 26px",
  fontSize: "1.125rem",
  ".MuiTypography-root": {
    "&:first-child": { lineHeight: "1" },
    "&:last-child": {
      lineHeight: "1",
      a: { color: theme.palette.textMain.main },
    },
  },
}));

export const InvoiceEmailStyles = styled(Box)(({ theme }) => ({
  gridColumn: "1 / -1",
  width: "calc((100% - 48px) / 2)",
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  padding: "8px 16px",
  marginBottom: "16px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.primary.light}`,
  borderRadius: "4px",
  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.05)",
}));

export const InvoiceEmailInput = styled(Box)(({ theme }) => ({
  padding: "4px 8px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "4px",
  backgroundColor: theme.palette.action.disabledBackground,
  fontSize: "1rem",
  color: theme.palette.text.primary,
  marginLeft: "auto",
  marginRight: "8px",
  maxWidth: "300px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));